import React from 'react';
import styled from 'styled-components';

import {
  Button,
  Icon,
  Title,
  Link,
  Text,
  SVGInterview,
  SVGLogoV2,
  VerticalSpace,
} from '@brokerbay/design-components';
import { CONTACT_SUPPORT_LINK, SUPPORT_EMAIL } from 'utils';

const NoFeatureFlagPage: React.FC = () => (
    <Container>
      <BrokerBayLogo />
      <ContentContainer>
        <FlexVerticalSpace size="large">
          <SVGInterview />
          <StyledTitle level={1}>
            You do not have permissions to view this page
          </StyledTitle>
          <StyledText>
            Please contact support@brokerbay.com for more information
            <Link href={`mailto:${SUPPORT_EMAIL}`}> {SUPPORT_EMAIL}</Link>
          </StyledText>
          <Button
            icon={<Icon color="white" type="antdMailOutlined" />}
            type="primary"
            href={CONTACT_SUPPORT_LINK}
          >
            Contact Support
          </Button>
        </FlexVerticalSpace>
      </ContentContainer>
    </Container>
  );

export default NoFeatureFlagPage;

const Container = styled.div`
  background-color: #fafcfd;
  height: calc(100vh - 89px);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTitle = styled(Title)`
  && {
    color: #4d628f;
    font-size: 32px;
    text-align: center;
    margin-bottom: 0px;
  }
`;

const StyledText = styled(Text)`
  && {
    color: #7081a5;
    text-align: center;
  }
`;

const ContentContainer = styled.div`
  margin: auto;
  width: 36vw;
`;

const FlexVerticalSpace = styled(VerticalSpace)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 36vw;
  text-align: center;
`;

const BrokerBayLogo = styled(SVGLogoV2)`
  position: absolute;
  margin: auto;
  top: calc(5px + 2vh);
  left: 0;
  right: 0;
  width: calc(95px + 3.8vw);
`;
